// extracted by mini-css-extract-plugin
export default {"select":"SelectDataItem_select__vxmGM","hiddenLabel":"SelectDataItem_hiddenLabel__cbP3r"};